import { NgModule } from '@angular/core';
import { DhhpButtonComponent } from './dhhp-button.component';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [DhhpButtonComponent],
  imports: [
    MatButtonModule,CommonModule
  ],
  exports: [DhhpButtonComponent,MatButtonModule]
})
export class DhhpButtonModule { }
